import { gql } from 'apollo-boost';

export const SEND_MESSAGE_TO_TELEGRAM = gql`
    mutation SendMessageToTelegram($data: SendMessageToTelegramInput!) {
        sendMessageToTelegram(data: $data)
    }
`;
